import { Controller, useForm, useFormContext } from "react-hook-form";

import { FormDialog } from "ui/form-dialog";
import { TextArea } from "ui/text-area";

import StrategyLink from "components/modals/shared/strategy-link";

import type {
  RefineEmailContentFormValues,
  RefineEmailContentModalProps,
} from "components/modals/refine-email-content-modal/refine-email-content-modal.types";

const RefineEmailContentFormFields = ({
  programStrategyLabel,
  programStrategyHref,
  campaignStrategyLabel,
  campaignStrategyHref,
}: Pick<
  RefineEmailContentModalProps,
  | "programStrategyLabel"
  | "programStrategyHref"
  | "campaignStrategyLabel"
  | "campaignStrategyHref"
>) => {
  const { control } = useFormContext<RefineEmailContentFormValues>();

  return (
    <>
      <Controller
        name="emailAdditionalInstructions"
        control={control}
        render={({ field: { onChange, value, ...field } }) => (
          <TextArea
            label={<span className="font-bold">Email additional instructions</span>}
            value={value || ""}
            onChange={(event) => onChange(event.target.value)}
            rows={5}
            {...field}
          />
        )}
      />

      <div className="flex flex-col gap-2 w-full">
        <StrategyLink
          label="Program strategy:"
          href={programStrategyHref}
          linkLabel={programStrategyLabel}
        />
        <StrategyLink
          label="Campaign strategy:"
          href={campaignStrategyHref}
          linkLabel={campaignStrategyLabel}
        />
      </div>
    </>
  );
};

const RefineEmailContentModal = ({
  onCloseCallback,
  onConfirmCallback,
  programStrategyLabel,
  programStrategyHref,
  campaignStrategyLabel,
  campaignStrategyHref,
  isSubmitting = false,
}: RefineEmailContentModalProps) => {
  const form = useForm<RefineEmailContentFormValues>({
    mode: "onChange",
    shouldUnregister: true,
    defaultValues: { emailAdditionalInstructions: "" },
  });

  return (
    <FormDialog
      open
      onClose={onCloseCallback}
      headline="Refine email content"
      description="Enter custom prompt for this specific email and describe how you would like to improve email text."
      form={form}
      onSubmit={onConfirmCallback}
      submitting={isSubmitting}
      submitButtonText="Rewrite"
      submitLoadingMessage="Rewriting...">
      <RefineEmailContentFormFields
        programStrategyLabel={programStrategyLabel}
        programStrategyHref={programStrategyHref}
        campaignStrategyLabel={campaignStrategyLabel}
        campaignStrategyHref={campaignStrategyHref}
      />
    </FormDialog>
  );
};

export default RefineEmailContentModal;
